window.addEventListener('load', () => {
  if (window.Shopify.customerPrivacy?.userCanBeTracked()) {
    /* GOOGLE TAG MANAGER */
    // const shop = Shopify.shop?.split('.myshopify.com')[0];
    // switch (shop) {
    //   case 'apm-hk': // UK
    //     var container = 'GTM-MDHWG5P';
    //   case 'apm-mc': // US
    //     var container = 'GTM-MDHWG5P';
    //   case 'apm-fr': // FR
    //     var container = 'GTM-MSGBQVZ';
    //   case 'apm-uk': // INT
    //     var container = 'GTM-MDHWG5P';
    //   default:
    //     var container = 'GTM-MDHWG5P';
    // }
  
    /* GOOGLE ADWORDS */
    // window.dataLayer = window.dataLayer || [];
    // function gtag(){dataLayer.push(arguments);}
    // gtag('js', new Date());
    // gtag('config', 'AW-308770936');
  
    /* HOTJAR */
    (function(h,o,t,j,a,r){
      h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
      h._hjSettings={hjid:2539240,hjsv:6};
      a=o.getElementsByTagName('head')[0];
      r=o.createElement('script');r.async=1;
      r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
      a.appendChild(r);
    })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
  }
});

/* LIVE CHAT */
(function(u,t,d){
  var i=d.createElement(t);i.type='text/javascript';i.async=true;i.src=u;
  var s=d.getElementsByTagName(t)[0]; s.parentNode.insertBefore(i,s);
})('https://asia2-track.inside-graph.com/gtm/IN-1000872-US/include.js','script',document);

/* SPLITIT */
(function(i,s,o,g,r,a,m){i['SplititObject']=r;i[r]=i[r]||function(){
  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window, document, 'script', '//upstream.production.splitit.com/v1/dist/upstream-messaging.js?v=1', 'splitit');
splitit('init', { apiKey:  '8706c514-1720-49f4-afbd-551f4c3c9273', lang: 'en-US', currency: 'GBP', currencySymbol: '£', debug: false });


// Reload AfterShip Personalization after AJAX pagination
  document.addEventListener('facet:update', function() {
    // Use requestAnimationFrame to ensure DOM is fully updated
    requestAnimationFrame(function() {
      if (window.AfterShipPersonalization && typeof window.AfterShipPersonalization.reload === 'function') {
        window.AfterShipPersonalization.reload();
      }
    });
  });


const CART_DRAWER_OPEN_PARAM = 'cart_drawer_open';

function setCartDrawerOpenParam(isOpen) {
  const url = new URL(window.location.href);

  if (isOpen) {
    url.searchParams.set(CART_DRAWER_OPEN_PARAM, '1');
  } else {
    url.searchParams.delete(CART_DRAWER_OPEN_PARAM);
  }

  window.history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
}

function bindCartDrawerUrlParam() {
  const drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  drawer.addEventListener('dialog:after-show', () => setCartDrawerOpenParam(true));
  drawer.addEventListener('dialog:after-hide', () => setCartDrawerOpenParam(false));

  if (new URLSearchParams(window.location.search).get(CART_DRAWER_OPEN_PARAM) === '1' && !drawer.open) {
    drawer.show();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bindCartDrawerUrlParam);
} else {
  bindCartDrawerUrlParam();
}

const ACCOUNT_DOT_STORAGE_KEY = 'apm.headerAccountDotDismissed';

function dismissAccountDot() {
  try {
    window.localStorage.setItem(ACCOUNT_DOT_STORAGE_KEY, '1');
  } catch (e) {}
  document.documentElement.classList.add('account-dot-dismissed');
}

document.addEventListener('click', (event) => {
  const accountLink = event.target.closest?.('a');
  if (!accountLink?.querySelector('.header__account-dot')) return;
  dismissAccountDot();
});

function isCoarsePointer() {
  return window.matchMedia('(hover: none), (pointer: coarse)').matches;
}

function collapseQuickAddButtons(except) {
  document.querySelectorAll('.product-card__quick-add-button.is-expanded').forEach((button) => {
    if (button !== except) button.classList.remove('is-expanded');
  });
}

function openQuickAddAfterExpand(button) {
  button.dataset.quickAddOpening = 'true';

  if (button.type === 'submit' && button.form) {
    if (typeof button.form.requestSubmit === 'function') {
      button.form.requestSubmit(button);
    } else {
      button.click();
    }
  } else {
    button.click();
  }

  window.setTimeout(() => {
    delete button.dataset.quickAddOpening;
  }, 50);
}

document.addEventListener(
  'click',
  (event) => {
    const button = event.target.closest?.('.product-card__quick-add-button');
    if (!button || !isCoarsePointer()) return;
    if (button.dataset.quickAddOpening === 'true') return;

    event.preventDefault();
    event.stopPropagation();

    if (button.dataset.quickAddAnimating === 'true') return;

    collapseQuickAddButtons(button);
    button.classList.add('is-expanded');
    button.dataset.quickAddAnimating = 'true';

    window.setTimeout(() => {
      openQuickAddAfterExpand(button);
      delete button.dataset.quickAddAnimating;
    }, 1000);
  },
  true
);

function collapseQuickAddButtons() {
  document.querySelectorAll('.product-card__quick-add-button.is-expanded').forEach((button) => {
    button.classList.remove('is-expanded');
    button.blur();
  });
}

document.addEventListener(
  'dialog:before-hide',
  (event) => {
    if (!event.target.closest?.('quick-buy-modal') && event.target.localName !== 'quick-buy-modal') return;
    collapseQuickAddButtons();
  },
  true
);

document.addEventListener(
  'dialog:after-hide',
  (event) => {
    if (!event.target.closest?.('quick-buy-modal') && event.target.localName !== 'quick-buy-modal') return;
    collapseQuickAddButtons();
  },
  true
);

/* Mini-cart item removal confirmation / high-value retention popup */
(function () {
  const POPUP_ID = 'cart-removal-popup';
  const HOST_ID = 'cart-removal-popup-host';

  let popup = null;
  let copy = null;
  let activeItem = null;
  let isRetention = false;
  let isBusy = false;
  let isRemoving = false;
  let triggerButton = null;
  let activeItemEl = null;

  function cartDrawer() {
    return document.getElementById('cart-drawer');
  }

  function drawerBody(drawer) {
    return drawer?.shadowRoot?.querySelector('[part="body"]') || null;
  }

  function popupHost() {
    return document.getElementById(HOST_ID);
  }

  function decodeHtml(value) {
    if (typeof value !== 'string' || !value.includes('&')) return value;
    return value
      .replace(/&#0*39;/g, "'")
      .replace(/&#x0*27;/gi, "'")
      .replace(/&apos;/g, "'")
      .replace(/&#0*34;/g, '"')
      .replace(/&quot;/g, '"')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&');
  }

  function decodeCopy(value) {
    if (typeof value === 'string') return decodeHtml(value);
    if (!value || typeof value !== 'object') return value;
    return Object.fromEntries(Object.entries(value).map(([key, child]) => [key, decodeCopy(child)]));
  }

  function parseCopy(root) {
    const node = root.querySelector('[data-popup-copy]');
    if (!node) return null;
    try {
      return decodeCopy(JSON.parse(node.textContent));
    } catch (error) {
      return null;
    }
  }

  function isPopupTarget(target) {
    return !!(target && target.closest?.(`#${POPUP_ID}, .cart-removal-popup__card`));
  }

  function patchDrawerForPopup(drawer) {
    if (!drawer || drawer.dataset.popupPatched === 'true') return;
    drawer.dataset.popupPatched = 'true';

    const previousHide = drawer.hideForOutsideClickTarget.bind(drawer);
    drawer.hideForOutsideClickTarget = (target) => {
      if (isPopupTarget(target)) return false;
      return previousHide(target);
    };

    const previousAllow = drawer.allowOutsideClickForTarget.bind(drawer);
    drawer.allowOutsideClickForTarget = (target) => {
      if (isPopupTarget(target)) return true;
      return previousAllow(target);
    };

    drawer.addEventListener('dialog:before-hide', () => {
      if (popup && !popup.hidden) {
        closePopup('overlay', true, { restoreFocus: false });
      }
    });
  }

  function ensurePopup() {
    popup = document.getElementById(POPUP_ID);
    if (!popup) return null;

    const host = popupHost();
    if (popup.hidden && host && popup.parentNode !== host) {
      host.appendChild(popup);
    }

    patchDrawerForPopup(cartDrawer());
    copy = parseCopy(popup) || copy || fallbackCopy();
    bindPopup(popup);
    return popup;
  }

  function fallbackCopy() {
    return {
      standard: {
        title: 'REMOVE PRODUCT?',
        subtitle: 'Are you sure you want to remove the following product from the cart?',
        confirm: 'REMOVE',
        cancel: 'CANCEL',
        sr: ''
      },
      retention: {
        title: "DON'T LET THIS PIECE GO",
        subtitle: 'This product is popular with limited availability. Would you like to keep it?',
        confirm: 'NO, REMOVE',
        cancel: 'YES, KEEP IT',
        sr: 'This dialog is about the highest-value item you selected for removal.'
      }
    };
  }

  function bindAction(element, handler) {
    if (!element) return;

    let locked = false;
    const run = (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (locked) return;
      locked = true;
      handler();
      setTimeout(() => {
        locked = false;
      }, 400);
    };

    element.addEventListener('click', run);
    element.addEventListener('touchend', run, { passive: false });
  }

  function bindPopup(root) {
    if (!root || root.dataset.bound === 'true') return;
    root.dataset.bound = 'true';

    bindAction(root.querySelector('[data-popup-confirm]'), confirmRemoval);
    bindAction(root.querySelector('[data-popup-cancel]'), keepItem);
  }

  function syncHeaderCartCount(count) {
    const itemCount = Number(count) || 0;

    document.querySelectorAll('cart-count').forEach((el) => {
      el.itemCount = itemCount;
    });
    document.querySelectorAll('.cart-number').forEach((el) => {
      el.textContent = itemCount;
    });
    document.querySelectorAll('cart-dot').forEach((el) => {
      el.classList.toggle('is-visible', itemCount > 0);
    });

    const drawer = cartDrawer();
    drawer?.setAttribute('data-cart-item-count', String(itemCount));
  }

  function lineItems() {
    return Array.from(document.querySelectorAll('#cart-drawer .cart-drawer__items line-item[data-line-key]'));
  }

  function readItem(el) {
    const drawer = cartDrawer();
    return {
      key: el.getAttribute('data-line-key') || '',
      title: el.getAttribute('data-title') || '',
      sku: el.getAttribute('data-sku') || '',
      productId: el.getAttribute('data-product-id') || '',
      variantId: el.getAttribute('data-variant-id') || '',
      variantTitle: el.getAttribute('data-variant-title') || '',
      unitPrice: Number(el.getAttribute('data-unit-price') || 0),
      quantity: Number(el.getAttribute('data-quantity') || 0),
      linePrice: Number(el.getAttribute('data-line-price') || 0),
      cartTotal: Number(drawer?.getAttribute('data-cart-total') || 0),
      cartCount: lineItems().length,
      itemCount: Number(drawer?.getAttribute('data-cart-item-count') || 0)
    };
  }

  function highestValueItem(items) {
    const values = items.map((el) => Number(el.getAttribute('data-line-price') || 0));
    const hasPositive = values.some((value) => value > 0);
    let bestIndex = -1;
    let bestValue = -1;

    values.forEach((value, index) => {
      if (hasPositive && value <= 0) return;
      if (value > bestValue) {
        bestValue = value;
        bestIndex = index;
      }
    });

    return bestIndex >= 0 ? items[bestIndex] : items[0];
  }

  function analyticsContext(item, extra) {
    return {
      item_name: item.title,
      item_id: item.productId,
      item_sku: item.sku,
      item_variant: item.variantTitle || item.variantId,
      unit_price: item.unitPrice / 100,
      quantity: item.quantity,
      line_item_value: item.linePrice / 100,
      cart_total: item.cartTotal / 100,
      cart_count: item.cartCount,
      currency: cartDrawer()?.getAttribute('data-currency') || window.Shopify?.currency?.active || '',
      market: window.Shopify?.country || '',
      domain: window.location.hostname,
      device: window.innerWidth <= 768 ? 'mobile' : 'desktop',
      ...extra
    };
  }

  function track(eventName, item, extra) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...analyticsContext(item, extra)
    });
  }

  function mountIntoItem(itemEl) {
    if (!popup || !itemEl) return false;

    const slot = itemEl.querySelector('.line-item__confirm');
    const main = itemEl.querySelector('.line-item__main');
    if (!slot || !main) return false;

    main.hidden = true;
    itemEl.classList.add('is-confirming-removal');
    slot.hidden = false;
    slot.appendChild(popup);

    popup.hidden = false;
    popup.classList.add('is-open');
    popup.setAttribute('aria-hidden', 'false');
    cartDrawer()?.classList.add('has-removal-popup');
    return true;
  }

  function unmountFromItem() {
    if (!popup) return;

    const itemEl = activeItemEl?.isConnected ? activeItemEl : null;
    const slot = itemEl?.querySelector('.line-item__confirm');
    const main = itemEl?.querySelector('.line-item__main');

    popup.hidden = true;
    popup.classList.remove('is-open');
    popup.setAttribute('aria-hidden', 'true');
    cartDrawer()?.classList.remove('has-removal-popup');

    const host = popupHost();
    if (host) {
      host.appendChild(popup);
    }

    if (main) main.hidden = false;
    if (slot) slot.hidden = true;
    itemEl?.classList.remove('is-confirming-removal');
  }

  function applyCopy(mode) {
    const strings = copy?.[mode];
    if (!popup || !strings) return;

    const title = popup.querySelector('[data-popup-title]');
    const subtitle = popup.querySelector('[data-popup-subtitle]');
    const confirm = popup.querySelector('[data-popup-confirm]');
    const cancel = popup.querySelector('[data-popup-cancel]');
    if (!title || !subtitle || !confirm || !cancel) return;

    title.textContent = strings.title;
    subtitle.textContent = strings.subtitle;
    confirm.textContent = strings.confirm;
    cancel.textContent = strings.cancel;

    const sr = popup.querySelector('[data-popup-sr]');
    if (sr) {
      sr.textContent = strings.sr || '';
      sr.hidden = !strings.sr;
    }

    const describedBy = strings.sr
      ? 'cart-removal-popup-subtitle cart-removal-popup-sr'
      : 'cart-removal-popup-subtitle';
    popup.setAttribute('aria-describedby', describedBy);
  }

  function closePopup(method, trackDismiss, options) {
    if (!popup || popup.hidden) return;

    if (trackDismiss && activeItem) {
      track(
        isRetention ? 'cart_high_value_retention_popup_dismissed' : 'cart_standard_removal_popup_dismissed',
        activeItem,
        { dismissal_method: method }
      );
    }

    unmountFromItem();
    isBusy = false;

    const toFocus = triggerButton;
    activeItem = null;
    activeItemEl = null;
    isRetention = false;
    triggerButton = null;
    popup.querySelector('[data-popup-confirm]')?.removeAttribute('disabled');
    popup.querySelector('[data-popup-cancel]')?.removeAttribute('disabled');

    if (options?.restoreFocus !== false && toFocus?.isConnected) {
      toFocus.focus();
    }
  }

  function trapFocus(event) {
    if (event.key !== 'Tab' || !popup || popup.hidden) return;

    const focusable = Array.from(
      popup.querySelectorAll('button:not([hidden]):not([disabled]):not([tabindex="-1"])')
    );
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function openPopup(itemEl, trigger) {
    if (popup?.hidden !== false) isBusy = false;
    if (!ensurePopup() || isRemoving) return;

    copy = copy || fallbackCopy();
    const items = lineItems();
    const itemNode = itemEl || trigger?.closest('line-item');
    if (!itemNode) return;

    const item = readItem(itemNode);

    if (!item.key) {
      item.key = trigger?.getAttribute('data-line-key') || '';
    }

    if (!item.key && trigger?.href) {
      try {
        item.key = new URL(trigger.href, window.location.origin).searchParams.get('id') || '';
      } catch (error) {}
    }

    if (!item.key) return;

    const highest = items.length ? highestValueItem(items) : itemNode;
    isRetention = highest === itemNode;
    activeItem = item;
    activeItemEl = itemNode;
    triggerButton = trigger;
    isBusy = true;

    applyCopy(isRetention ? 'retention' : 'standard');

    if (!mountIntoItem(itemNode)) {
      activeItem = null;
      activeItemEl = null;
      triggerButton = null;
      isBusy = false;
      return;
    }

    track(
      isRetention ? 'cart_high_value_retention_popup_displayed' : 'cart_standard_removal_popup_displayed',
      item
    );

    popup.querySelector('[data-popup-confirm]')?.focus();
  }

  async function removeItem(item) {
    const drawer = cartDrawer();
    const scrollTop = drawerBody(drawer)?.scrollTop || 0;

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    try {
      const liveCart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      const matchingItem = (liveCart.items || []).find((line) => line.key === item.key);

      if (!matchingItem) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }

      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:prepare-bundled-sections', {
          bubbles: true,
          detail: { sections: sectionsToBundle }
        })
      );

      const cartContent = await (
        await fetch(`${Shopify.routes.root}cart/change.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: item.key,
            quantity: 0,
            sections: sectionsToBundle.join(',')
          })
        })
      ).json();

      if (cartContent.status && Number(cartContent.status) >= 400) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        return;
      }

      const lineItem = document.querySelector(`#cart-drawer line-item[data-line-key="${CSS.escape(item.key)}"]`);
      lineItem?.dispatchEvent(
        new CustomEvent('line-item:change', {
          bubbles: true,
          detail: { quantity: 0, cart: cartContent }
        })
      );

      document.documentElement.dispatchEvent(
        new CustomEvent('cart:change', {
          bubbles: true,
          detail: {
            baseEvent: 'line-item:change',
            cart: cartContent
          }
        })
      );

      syncHeaderCartCount(cartContent.item_count);

      requestAnimationFrame(() => {
        const body = drawerBody(cartDrawer());
        if (body) body.scrollTop = scrollTop;
      });
    } catch (error) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
    }
  }

  async function confirmRemoval() {
    if (!activeItem || !isBusy || isRemoving) return;

    const item = activeItem;
    const retention = isRetention;
    isRemoving = true;
    popup.querySelector('[data-popup-confirm]')?.setAttribute('disabled', 'disabled');
    popup.querySelector('[data-popup-cancel]')?.setAttribute('disabled', 'disabled');

    track(
      retention ? 'cart_high_value_removal_confirmed' : 'cart_standard_removal_confirmed',
      item
    );

    closePopup('confirm', false);
    try {
      await removeItem(item);
    } finally {
      isRemoving = false;
    }
  }

  function keepItem() {
    if (!activeItem) return;

    if (isRetention) {
      track('cart_high_value_item_kept', activeItem);
    }

    closePopup('keep', false);
  }

  function eventPath(event) {
    return typeof event.composedPath === 'function' ? event.composedPath() : [event.target];
  }

  function isInsidePopup(event) {
    return eventPath(event).some((node) => {
      return node instanceof Element && !!node.closest?.(`#${POPUP_ID}`);
    });
  }

  function isInsideCartDrawer(event) {
    const drawer = cartDrawer();
    return !!drawer && eventPath(event).some((node) => node === drawer);
  }

  function isDrawerCloseControl(event) {
    return eventPath(event).some((node) => {
      if (!(node instanceof Element)) return false;
      const part = node.getAttribute('part') || '';
      return part === 'overlay' || part === 'close-button' || part.split(' ').includes('close-button');
    });
  }

  function findRemoveTrigger(event) {
    for (const node of eventPath(event)) {
      if (!(node instanceof Element)) continue;
      if (node.closest('quantity-selector')) {
        const link = node.closest('a[href*="/cart/change"]');
        if (!link || !link.closest('#cart-drawer')) return null;
        const quantity = new URL(link.href, window.location.origin).searchParams.get('quantity');
        return quantity === '0' ? link : null;
      }
      if (node.matches('.js-mini-cart-remove')) return node;
    }
    return null;
  }

  function dismissIfOutside(event) {
    if (!popup || popup.hidden || isRemoving) return false;
    if (isInsidePopup(event)) return false;

    if (isDrawerCloseControl(event) || !isInsideCartDrawer(event)) {
      closePopup('overlay', true, { restoreFocus: false });
      return false;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    closePopup('overlay', true);
    return true;
  }

  document.addEventListener(
    'click',
    (event) => {
      if (dismissIfOutside(event)) return;

      const trigger = findRemoveTrigger(event);
      if (!trigger || !trigger.closest('#cart-drawer')) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (popup && !popup.hidden) return;
      if (isRemoving) return;
      if (popup?.hidden !== false) isBusy = false;

      openPopup(trigger.closest('line-item'), trigger);
    },
    true
  );

  let touchStartY = 0;
  let touchMoved = false;

  document.addEventListener(
    'touchstart',
    (event) => {
      touchStartY = event.touches[0]?.clientY || 0;
      touchMoved = false;
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchmove',
    (event) => {
      const y = event.touches[0]?.clientY || 0;
      if (Math.abs(y - touchStartY) > 8) touchMoved = true;
    },
    { capture: true, passive: true }
  );

  document.addEventListener(
    'touchend',
    (event) => {
      if (touchMoved) return;
      dismissIfOutside(event);
    },
    { capture: true, passive: false }
  );

  window.addEventListener(
    'keydown',
    (event) => {
      if (!popup || popup.hidden) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        event.stopImmediatePropagation();
        closePopup('escape', true);
        return;
      }

      trapFocus(event);
    },
    true
  );

  document.addEventListener('cart:change', () => {
    if (popup && !popup.hidden && !isRemoving) {
      closePopup('cart_sync', false);
    }
    requestAnimationFrame(ensurePopup);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ensurePopup);
  } else {
    ensurePopup();
  }
})();

function collapseQuickAddButtons() {
  document.querySelectorAll('.product-card__quick-add-button.is-expanded').forEach((button) => {
    button.classList.remove('is-expanded');
    button.blur();
  });
}

document.addEventListener(
  'dialog:before-hide',
  (event) => {
    if (!event.target.closest?.('quick-buy-modal') && event.target.localName !== 'quick-buy-modal') return;
    collapseQuickAddButtons();
  },
  true
);

document.addEventListener(
  'dialog:after-hide',
  (event) => {
    if (!event.target.closest?.('quick-buy-modal') && event.target.localName !== 'quick-buy-modal') return;
    collapseQuickAddButtons();
  },
  true
);

/* Replay the Clear filters hover wipe on touch before the facet update */
(() => {
  const WIPE_MS = 450;
  const touchQuery = window.matchMedia('(hover: none), (pointer: coarse)');

  document.addEventListener(
    'click',
    (event) => {
      if (!touchQuery.matches) return;

      const link = event.target.closest('a.facets-clear-all');
      if (!link || link.dataset.clearWipeReady === '1') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      link.classList.add('is-wiping');

      window.setTimeout(() => {
        link.dataset.clearWipeReady = '1';
        link.click();
      }, WIPE_MS);
    },
    true
  );
})();